const PROFILE_TYPE = {
    STUDENT: 'Student',
    APPLICATION: 'Application',
    ENQUIRY: 'Enquiry',
    NONE: ''
};

export default PROFILE_TYPE;